import React, { useState, useEffect } from 'react';
import { View, Text, StyleSheet, Alert } from 'react-native';
import { useTheme } from '@react-navigation/native';
import { Button, HeaderScroll, Input, LoadingHeader } from '../../component';
import API from '../../API';
import * as Google from 'expo-auth-session/providers/google'
import * as AppleAuthentication from 'expo-apple-authentication';

const GOOGLE_CREDENTIALS = API.GOOGLE_CREDENTIALS;

var Password = props=>{
	var { colors, dark } = useTheme();
	var [connections, setConnections] = useState(null);
	var [oldPassword, setOldPassword] = useState('');
	var [newPassword, setNewPassword] = useState('');
	var [newPasswordRepeat, setNewPasswordRepeat] = useState('');
	var [loading, setLoading] = useState(false);

	const [request, response, requestGoogleAuth] = Google.useAuthRequest({	
		expoClientId: GOOGLE_CREDENTIALS.web.client,
		iosClientId: GOOGLE_CREDENTIALS.ios[GOOGLE_CREDENTIALS.is_dev ? 'dev' : 'live'],
		androidClientId: GOOGLE_CREDENTIALS.android,
		webClientId: GOOGLE_CREDENTIALS.web,
	});

	useEffect(()=>{
		if(connections===null){
			API.getConnections().then(res=>{
				if(res.error){
					Alert.alert('Error', 'Unexpected error loading user\'s password info.');
					return props.navigation.goBack();
				}
				setConnections(res.data);
			}).catch(err=>{
				Alert.alert('Error', 'Unexpected error loading user\'s password info.');
				props.navigation.goBack();
			})
		}
		if(response?.type==='success'){
			if(!response.authentication.idToken){
				return Alert.alert('Error', 'Unexpected error logging in with Google.');
			}
			sendChange(null, response.authentication.idToken);
		}
	}, [response])

	var styles = StyleSheet.create({
		disclamer: {
			color: colors.text,
			textAlign: 'center',
			padding: 10
		}
	});

	var verifyForm = ()=>{
		if(connections.has_password && oldPassword.length<5){
			Alert.alert('Invalid current password', 'The current password must be at least 5 characters long.');
			return false;
		}
		if(newPassword.length<8){
			Alert.alert('Invalid new password', 'The new password must be at least 8 characters long.');
			return false;
		} 
		if(newPassword!=newPasswordRepeat){
			Alert.alert('Invalid new password', 'The new passwords do not match.');
			return false;
		}
		return true;
	}
	
	var sendChange = (apple_auth=null, google_auth=null)=>{
		if((!oldPassword || oldPassword.length<5) && !apple_auth && !google_auth) return;
		setLoading(true);
		API.changePassword(newPassword, (!oldPassword || oldPassword.length<5) ? null : oldPassword, apple_auth, google_auth).then(res=>{
			setLoading(false);
			if(res.error) return Alert.alert('Error', res.message_client);
			Alert.alert('Password changed!');
			props.navigation.goBack();
		}).catch(err=>{
			setLoading(false);
			return Alert.alert('Error', 'Unexpected error changing password (LCL-3)');
		});
	}
	
	var authPassword = ()=>{
		var valid = verifyForm();
		if(!valid) return;
		sendChange();
	}

	var authApple = ()=>{
		var valid = verifyForm();
		if(!valid) return;

		setLoading(true);
		AppleAuthentication.signInAsync({
			requestedScopes: [AppleAuthentication.AppleAuthenticationScope.EMAIL],
		}).then(creds=>{
			if(!creds || !creds.identityToken){
				setLoading(false);
				return Alert.alert('Error', 'Could not authenticate Apple account (LCL-2).');
			}
			sendChange(creds.identityToken);
		}).catch(err=>{
			setLoading(false);
			if(err.code === 'ERR_CANCELED') return;
			return Alert.alert('Error', 'There was an error authenticating Apple account (LCL-1).');
		})
	}

	var authGoogle = ()=>{
		var valid = verifyForm();
		if(!valid) return;
		requestGoogleAuth();
	}

	return (
		<HeaderScroll
			headerText='Change password'
		>
			{connections ? (
				<View>
					{connections.has_password ? (
						<Input label='Current password' value={oldPassword} onChangeText={setOldPassword} password editable={!loading} />
					) : null}
					<Input label='New password' value={newPassword} onChangeText={setNewPassword} password editable={!loading} />
					<Input label='Repeat new password' value={newPasswordRepeat} onChangeText={setNewPasswordRepeat} password editable={!loading} />
					{loading ? (
						<LoadingHeader text='Changing password...' />
					) : !connections.has_password ? (
						<View>
							<Text style={styles.disclamer}>Since this account has no previous password, you will need to authenticate with the connected account.</Text>
							{Platform.OS=='ios' && connections.apple_auth ? (
								<AppleAuthentication.AppleAuthenticationButton
									buttonType={AppleAuthentication.AppleAuthenticationButtonType.SIGN_IN}
									buttonStyle={AppleAuthentication.AppleAuthenticationButtonStyle[dark ? 'WHITE' : 'BLACK']}
									cornerRadius={9}
									style={{ height: 50, marginTop: 5, marginHorizontal: 2 }}
									onPress={authApple}
								/>
							) : null}
							{connections.google_auth && <Button text={'Sign in with Google'} onPress={authGoogle} color={'#4285F4'} textColor={'white'} height={50} style={{ marginTop: 10 }} icon={'google'} />}
						</View>
					) : (
						<Button text="Change password" onPress={authPassword} style={{ marginTop: 20 }} />
					)}
				</View>
			) : (
				<LoadingHeader text='Loading password info...' />
			)}
		</HeaderScroll>
	)
}

export default Password;